import { render, staticRenderFns } from "./ValidatePassword.vue?vue&type=template&id=4de80160"
import script from "./ValidatePassword.vue?vue&type=script&lang=js"
export * from "./ValidatePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports